import { ethers } from 'ethers';
/**
 * 简略地址
 * @param value 地址
 * @param head 前面的数量
 * @param tail 后面的数量
 * @returns 简略后的地址
 */
export const shortenAddress = (value: string, head = 6, tail = 6): string => {
  if (value.length <= head + tail) return value;
  return `${value.slice(0, head)}...${value.slice(-tail)}`;
};

export function isSameAddress(address1?: string, address2?: string) {
  if (!address1 || !address2) return false;
  return address1.toLowerCase() === address2.toLowerCase();
}

export function safeParseEvmAddress(address?: string): string {
  try {
    return ethers.utils.getAddress(address?.toLowerCase());
  } catch (err) {
    // console.log(err);
    return address;
  }
}
